import { useLang } from '../context/LanguageContext';
import { useSubscriptionGate } from '../context/SubscriptionGateContext';
import { shareSiteOnWhatsApp, trackEvent } from '../utils/analytics';
import { SITE_URL } from '../config/env.js';
import './MarketingPromoBar.css';

export default function MarketingPromoBar() {
  const { t } = useLang();
  const { hasFullAccess, openSubscribe } = useSubscriptionGate();

  if (hasFullAccess) return null;

  const handleShare = () => {
    trackEvent('share_site', { method: 'whatsapp' });
    shareSiteOnWhatsApp(t.marketingShareText, SITE_URL);
  };

  const handleSubscribe = () => {
    trackEvent('subscribe_cta_click', { placement: 'promo_bar' });
    openSubscribe();
  };

  return (
    <aside className="mkt-promo" data-sub-free aria-label="Subscription offer">
      <div className="mkt-promo__inner">
        <span className="mkt-promo__badge">{t.marketingBadge}</span>
        <p className="mkt-promo__text">{t.marketingPromoText}</p>
        <div className="mkt-promo__actions">
          <button type="button" className="mkt-promo__btn mkt-promo__btn--primary" onClick={handleSubscribe}>
            {t.marketingSubscribeBtn}
          </button>
          <button type="button" className="mkt-promo__btn mkt-promo__btn--ghost" onClick={handleShare}>
            {t.marketingShareBtn}
          </button>
        </div>
      </div>
    </aside>
  );
}
